//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import { BaseNomDTO } from '../ControlsApi/api';
import { REACT_APP_LOGIN_PAGE } from '../../KeyVariables';

export class Client {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();
        this.baseUrl = baseUrl ?? "";
        this.instance.interceptors.request.use(
            config => {
                const token = localStorage.getItem('accessToken');
                if (token) {
                    if (!config.headers) {
                        config.headers = {};
                    }
                    config.headers['Authorization'] = `Bearer ${token}`;
                }
                return config;
            },
            error => {
                return Promise.reject(error);
            }
        );
        this.instance.interceptors.response.use(
          response => response,
          error => {
              if (error.response && error.response.status === 401) {
                  const token = localStorage.getItem('accessToken');
                  window.location.href = REACT_APP_LOGIN_PAGE;
              }
              return Promise.reject(error);
          }
      );
    }
    employeedashboardaccess( cancelToken?: CancelToken | undefined): Promise<boolean> {
      let url_ = this.baseUrl + "/api/dashboard/employeedashboardaccess";
      url_ = url_.replace(/[?&]$/, "");

      let options_: AxiosRequestConfig = {
          method: "GET",
          url: url_,
          headers: {
              "Accept": "text/plain"
          },
          cancelToken
      };

      return this.instance.request(options_).catch((_error: any) => {
          if (isAxiosError(_error) && _error.response) {
              return _error.response;
          } else {
              throw _error;
          }
      }).then((_response: AxiosResponse) => {
          return this.processEmployeedashboardaccess(_response);
      });
  }

  protected processEmployeedashboardaccess(response: AxiosResponse): Promise<boolean> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && typeof response.headers === "object") {
          for (let k in response.headers) {
              if (response.headers.hasOwnProperty(k)) {
                  _headers[k] = response.headers[k];
              }
          }
      }
      if (status === 200) {
          const _responseText = response.data;
          let result200: any = null;
          let resultData200  = _responseText;
              result200 = resultData200 !== undefined ? resultData200 : <any>null;
  
          return Promise.resolve<boolean>(result200);

      } else if (status !== 200 && status !== 204) {
          const _responseText = response.data;
          return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }
      return Promise.resolve<boolean>(null as any);
  }
  logout(cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/dashboard/logout";
    url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            withCredentials: true,
            headers: {
            },
            cancelToken
        };
       
        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

  protected processLogout(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return Success
   */
  getcurrentuser(cancelToken?: CancelToken): Promise<any> {
    let url_ = this.baseUrl + "/api/dashboard/getcurrentuser";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      withCredentials: true,
      headers: {
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (_error.response.status === 401) {
      
      } if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetcurrentuser(_response);
    });
  }

  protected processGetcurrentuser(response: AxiosResponse): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      return Promise.resolve(response.data);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<any>(null as any);
  }

  /**
   * @return Success
   */
  getavailablecomponents(cancelToken?: CancelToken): Promise<ComponentIcon[]> {
    let url_ = this.baseUrl + "/api/dashboard/getavailablecomponents";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      withCredentials: true,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (_error.response.status === 401) {
      
      } if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetavailablecomponents(_response);
    });
  }

  protected processGetavailablecomponents(response: AxiosResponse): Promise<ComponentIcon[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ComponentIcon.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<ComponentIcon[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ComponentIcon[]>(null as any);
  }


  /**
   * @param search (optional) 
   * @return Success
   */
  handlesearch(search?: string | undefined, cancelToken?: CancelToken): Promise<string> {
    let url_ = this.baseUrl + "/api/dashboard/handlesearch?";
    if (search === null)
      throw new Error("The parameter 'search' cannot be null.");
    else if (search !== undefined)
      url_ += "search=" + encodeURIComponent("" + search) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      withCredentials: true,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (_error.response.status === 401) {
      
      } if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processHandlesearch(_response);
    });
  }

  protected processHandlesearch(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
  }



  /**
   * @return Success
   */
  getclinics(cancelToken?: CancelToken): Promise<ClinicDTO[]> {
    let url_ = this.baseUrl + "/api/dashboard/getclinics";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      withCredentials: true,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (_error.response.status === 401) {
      
      } if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetclinics(_response);
    });
  }

  protected processGetclinics(response: AxiosResponse): Promise<ClinicDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(ClinicDTO.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<ClinicDTO[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ClinicDTO[]>(null as any);
  }


  /**
   * @return Success
   */
  getnotifications(pageNumber?: number | undefined, pageSize?: number | undefined, cancelToken?: CancelToken): Promise<MessageDto[]> {
    let url_ = this.baseUrl + "/api/notify/getnotifications?";
    if (pageNumber === null)
      throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      withCredentials: true,
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (_error.response.status === 401) {
      
      } if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetnotifications(_response);
    });
  }

  protected processGetnotifications(response: AxiosResponse): Promise<MessageDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(MessageDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<MessageDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<MessageDto[]>(null as any);
  }

  cashmachinelist( cancelToken?: CancelToken): Promise<CashMachineDTO[]> {
    let url_ = this.baseUrl + "/api/cashmachine/cashmachinelist";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        method: "GET",
        url: url_,
        headers: {
            "Accept": "text/plain"
        },
        cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return this.processCashmachinelist(_response);
    });
}

protected processCashmachinelist(response: AxiosResponse): Promise<CashMachineDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (const k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
                result200!.push(CashMachineDTO.fromJS(item));
        }
        else {
            result200 = <any>null;
        }
        return Promise.resolve<CashMachineDTO[]>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<CashMachineDTO[]>(null as any);
}

  /**
   * @return Success
   */
  getnotificationscount(cancelToken?: CancelToken): Promise<number> {
    let url_ = this.baseUrl + "/api/notify/getnotificationscount";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      withCredentials: true,
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (_error.response.status === 401) {
      
      } if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetnotificationscount(_response);
    });
  }

  protected processGetnotificationscount(response: AxiosResponse): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<number>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<number>(null as any);
  }

  /**
   * @param messageId (optional) 
   * @return Success
   */
  dismissnotify(messageId?: number | undefined, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/notify/dismissnotify?";
    if (messageId === null)
      throw new Error("The parameter 'messageId' cannot be null.");
    else if (messageId !== undefined)
      url_ += "messageId=" + encodeURIComponent("" + messageId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      withCredentials: true,
      headers: {
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (_error.response.status === 401) {
      
      } if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDismissnotify(_response);
    });
  }

  protected processDismissnotify(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return Success
   */
  dismissallnotify(cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/notify/dismissallnotify";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      withCredentials: true,
      headers: {
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (_error.response.status === 401) {
      
      } if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processDismissallnotify(_response);
    });
  }

  protected processDismissallnotify(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }


  /**
   * @return Success
   */
  getnavigation(cancelToken?: CancelToken): Promise<NavigationMenuGroup[]> {
    let url_ = this.baseUrl + "/api/dashboard/getnavigation";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      withCredentials: true,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (_error.response.status === 401) {
      
      } if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetnavigation(_response);
    });
  }

  protected processGetnavigation(response: AxiosResponse): Promise<NavigationMenuGroup[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(NavigationMenuGroup.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<NavigationMenuGroup[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<NavigationMenuGroup[]>(null as any);
  }

  gettasks(pageNumber?: number | undefined, pageSize?: number | undefined, cancelToken?: CancelToken): Promise<MessageDto[]> {
    let url_ = this.baseUrl + "/api/task/gettasks?";
    if (pageNumber === null)
      throw new Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined)
      url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
    if (pageSize === null)
      throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined)
      url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      withCredentials: true,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (_error.response.status === 401) {
      
      } if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGettasks(_response);
    });
  }

  protected processGettasks(response: AxiosResponse): Promise<MessageDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(MessageDto.fromJS(item));
      }
      else {
        result200 = <any>null;
      }
      return Promise.resolve<MessageDto[]>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<MessageDto[]>(null as any);
  }

  /**
     * @param applicationId (optional) 
     * @return OK
     */
  getdashboards(applicationId?: number | undefined, cancelToken?: CancelToken): Promise<DashboardResponse> {
    let url_ = this.baseUrl + "/api/dashboard/getdashboards?";
    if (applicationId === null)
        throw new Error("The parameter 'applicationId' cannot be null.");
    else if (applicationId !== undefined)
        url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        method: "GET",
        url: url_,
        headers: {
            "Accept": "text/plain"
        },
        cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return this.processGetdashboards(_response);
    });
}

protected processGetdashboards(response: AxiosResponse): Promise<DashboardResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (const k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = DashboardResponse.fromJS(resultData200);
        return Promise.resolve<DashboardResponse>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<DashboardResponse>(null as any);
}

  getdashboardprops(tag?: string | undefined, cancelToken?: CancelToken): Promise<Dashboard> {
    let url_ = this.baseUrl + "/api/dashboard/getdashboardprops?";
    if (tag === null)
      throw new Error("The parameter 'tag' cannot be null.");
    else if (tag !== undefined)
      url_ += "tag=" + encodeURIComponent("" + tag) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGetdashboardprops(_response);
    });
  }

  protected processGetdashboardprops(response: AxiosResponse): Promise<Dashboard> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = Dashboard.fromJS(resultData200);
      return Promise.resolve<Dashboard>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Dashboard>(null as any);
  }

  /**
   * @return Success
   */
  gettaskscount(cancelToken?: CancelToken): Promise<number> {
    let url_ = this.baseUrl + "/api/task/gettaskscount";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      withCredentials: true,
      headers: {
        "Accept": "text/plain"
      },
      cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
      if (_error.response.status === 401) {
      
      } if (isAxiosError(_error) && _error.response) {
        return _error.response;
      } else {
        throw _error;
      }
    }).then((_response: AxiosResponse) => {
      return this.processGettaskscount(_response);
    });
  }

  protected processGettaskscount(response: AxiosResponse): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<number>(result200);

    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<number>(null as any);
  }

  addtask(body?: MedTaskDTO | undefined, cancelToken?: CancelToken): Promise<MedTaskDTO> {
    let url_ = this.baseUrl + "/api/task/addtask";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Content-Type": "application/json",
            "Accept": "text/plain"
        },
        cancelToken
    };

    return this.instance.request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return this.processAddtask(_response);
    });
}

protected processAddtask(response: AxiosResponse): Promise<MedTaskDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (const k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = MedTaskDTO.fromJS(resultData200);
        return Promise.resolve<MedTaskDTO>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<MedTaskDTO>(null as any);
}

}


export class NavigationItem implements INavigationItem {
  id?: number;
  name?: string | null;
  componentId?: number;
  url?: string | null;
  reactIcon?: string | null;
  reportId?: number | null;
  navigationTypeId?: number;
  readonly fullUrl?: string | null;

  constructor(data?: INavigationItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.componentId = _data["componentId"] !== undefined ? _data["componentId"] : <any>null;
      this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
      this.reactIcon = _data["reactIcon"] !== undefined ? _data["reactIcon"] : <any>null;
      this.reportId = _data["reportId"] !== undefined ? _data["reportId"] : <any>null;
      this.navigationTypeId = _data["navigationTypeId"] !== undefined ? _data["navigationTypeId"] : <any>null;
      (<any>this).fullUrl = _data["fullUrl"] !== undefined ? _data["fullUrl"] : <any>null;
    }
  }

  static fromJS(data: any): NavigationItem {
    data = typeof data === 'object' ? data : {};
    let result = new NavigationItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["componentId"] = this.componentId !== undefined ? this.componentId : <any>null;
    data["url"] = this.url !== undefined ? this.url : <any>null;
    data["reactIcon"] = this.reactIcon !== undefined ? this.reactIcon : <any>null;
    data["reportId"] = this.reportId !== undefined ? this.reportId : <any>null;
    data["navigationTypeId"] = this.navigationTypeId !== undefined ? this.navigationTypeId : <any>null;
    data["fullUrl"] = this.fullUrl !== undefined ? this.fullUrl : <any>null;
    return data;
  }
}

export interface INavigationItem {
  id?: number;
  name?: string | null;
  componentId?: number;
  url?: string | null;
  reactIcon?: string | null;
  reportId?: number | null;
  navigationTypeId?: number;
  fullUrl?: string | null;
}

export class NavigationMenuGroup implements INavigationMenuGroup {
  id?: number;
  name?: string | null;
  sortOrder?: number | null;
  items?: NavigationMenuItem[] | null;

  constructor(data?: INavigationMenuGroup) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"])
          this.items!.push(NavigationMenuItem.fromJS(item));
      }
      else {
        this.items = <any>null;
      }
    }
  }

  static fromJS(data: any): NavigationMenuGroup {
    data = typeof data === 'object' ? data : {};
    let result = new NavigationMenuGroup();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items)
        data["items"].push(item.toJSON());
    }
    return data;
  }


}

export interface INavigationMenuGroup {
  id?: number;
  name?: string | null;
  sortOrder?: number | null;
  items?: NavigationMenuItem[] | null;
}

export class NavigationMenuItem implements INavigationMenuItem {
  id?: number;
  name?: string | null;
  sortOrder?: number | null;
  showOnDashboard?: boolean;
  showInMenu?: boolean;
  navigationMenuGroupId?: number | null;
  navigationItem?: NavigationItem;

  constructor(data?: INavigationMenuItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
      this.showOnDashboard = _data["showOnDashboard"] !== undefined ? _data["showOnDashboard"] : <any>null;
      this.showInMenu = _data["showInMenu"] !== undefined ? _data["showInMenu"] : <any>null;
      this.navigationMenuGroupId = _data["navigationMenuGroupId"] !== undefined ? _data["navigationMenuGroupId"] : <any>null;
      this.navigationItem = _data["navigationItem"] ? NavigationItem.fromJS(_data["navigationItem"]) : <any>null;
    }
  }

  static fromJS(data: any): NavigationMenuItem {
    data = typeof data === 'object' ? data : {};
    let result = new NavigationMenuItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
    data["showOnDashboard"] = this.showOnDashboard !== undefined ? this.showOnDashboard : <any>null;
    data["showInMenu"] = this.showInMenu !== undefined ? this.showInMenu : <any>null;
    data["navigationMenuGroupId"] = this.navigationMenuGroupId !== undefined ? this.navigationMenuGroupId : <any>null;
    data["navigationItem"] = this.navigationItem ? this.navigationItem.toJSON() : <any>null;
    return data;
  }
}

export interface INavigationMenuItem {
  id?: number;
  name?: string | null;
  sortOrder?: number | null;
  showOnDashboard?: boolean;
  showInMenu?: boolean;
  navigationMenuGroupId?: number | null;
  navigationItem?: NavigationItem;
}


export class MessageDto implements IMessageDto {
  id?: number;
  personId?: number;
  subject?: string | null;
  body?: string | null;
  type?: string | null;
  component?: string | null;
  dateTime?: string | null;
  documentId?: number | null;

  constructor(data?: IMessageDto) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.personId = _data["personId"] !== undefined ? _data["personId"] : <any>null;
          this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
          this.body = _data["body"] !== undefined ? _data["body"] : <any>null;
          this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
          this.component = _data["component"] !== undefined ? _data["component"] : <any>null;
          this.dateTime = _data["dateTime"] !== undefined ? _data["dateTime"] : <any>null;
          this.documentId = _data["documentId"] !== undefined ? _data["documentId"] : <any>null;
      }
  }

  static fromJS(data: any): MessageDto {
      data = typeof data === 'object' ? data : {};
      let result = new MessageDto();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["personId"] = this.personId !== undefined ? this.personId : <any>null;
      data["subject"] = this.subject !== undefined ? this.subject : <any>null;
      data["body"] = this.body !== undefined ? this.body : <any>null;
      data["type"] = this.type !== undefined ? this.type : <any>null;
      data["component"] = this.component !== undefined ? this.component : <any>null;
      data["dateTime"] = this.dateTime !== undefined ? this.dateTime : <any>null;
      data["documentId"] = this.documentId !== undefined ? this.documentId : <any>null;
      return data;
  }
}

export interface IMessageDto {
  id?: number;
  personId?: number;
  subject?: string | null;
  body?: string | null;
  type?: string | null;
  component?: string | null;
  dateTime?: string | null;
  documentId?: number | null;
}

export class ClinicDTO implements IClinicDTO {
  id?: number;
  deletedBy?: number | null;
  name?: string | null;

  constructor(data?: IClinicDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.deletedBy = _data["deletedBy"] !== undefined ? _data["deletedBy"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
    }
  }

  static fromJS(data: any): ClinicDTO {
    data = typeof data === 'object' ? data : {};
    let result = new ClinicDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["deletedBy"] = this.deletedBy !== undefined ? this.deletedBy : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    return data;
  }
}

export interface IClinicDTO {
  id?: number;
  deletedBy?: number | null;
  name?: string | null;
}

export class ComponentIcon implements IComponentIcon {
  name?: string | null;
  url?: string | null;
  icon?: string | null;
  sortOrder?: number | null;

  constructor(data?: IComponentIcon) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
      this.icon = _data["icon"] !== undefined ? _data["icon"] : <any>null;
      this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
    }
  }

  static fromJS(data: any): ComponentIcon {
    data = typeof data === 'object' ? data : {};
    let result = new ComponentIcon();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["url"] = this.url !== undefined ? this.url : <any>null;
    data["icon"] = this.icon !== undefined ? this.icon : <any>null;
    data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
    return data;
  }
}

export interface IComponentIcon {
  name?: string | null;
  url?: string | null;
  icon?: string | null;
  sortOrder?: number | null;
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}


export class Dashboard implements IDashboard {
  id?: number;
  name?: string | null;
  tag?: string | null;
  widgets?: DashboardWidget[] | null;
  icons?: DashboardIcon[] | null;
  iconGroups?: DashboardIconGroup[] | null;

  constructor(data?: IDashboard) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
      if (Array.isArray(_data["widgets"])) {
        this.widgets = [] as any;
        for (let item of _data["widgets"])
          this.widgets!.push(DashboardWidget.fromJS(item));
      }
      else {
        this.widgets = <any>null;
      }
      if (Array.isArray(_data["icons"])) {
        this.icons = [] as any;
        for (let item of _data["icons"])
          this.icons!.push(DashboardIcon.fromJS(item));
      }
      else {
        this.icons = <any>null;
      }
      if (Array.isArray(_data["iconGroups"])) {
        this.iconGroups = [] as any;
        for (let item of _data["iconGroups"])
          this.iconGroups!.push(DashboardIconGroup.fromJS(item));
      }
      else {
        this.iconGroups = <any>null;
      }
    }
  }

  static fromJS(data: any): Dashboard {
    data = typeof data === 'object' ? data : {};
    let result = new Dashboard();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    data["tag"] = this.tag !== undefined ? this.tag : <any>null;
    if (Array.isArray(this.widgets)) {
      data["widgets"] = [];
      for (let item of this.widgets)
        data["widgets"].push(item.toJSON());
    }
    if (Array.isArray(this.icons)) {
      data["icons"] = [];
      for (let item of this.icons)
        data["icons"].push(item.toJSON());
    }
    if (Array.isArray(this.iconGroups)) {
      data["iconGroups"] = [];
      for (let item of this.iconGroups)
        data["iconGroups"].push(item.toJSON());
    }
    return data;
  }
}

export interface IDashboard {
  id?: number;
  name?: string | null;
  tag?: string | null;
  widgets?: DashboardWidget[] | null;
  icons?: DashboardIcon[] | null;
  iconGroups?: DashboardIconGroup[] | null;
}

export class DashboardIcon implements IDashboardIcon {
  id?: number;
  navigationMenuItem?: NavigationMenuItem;
  dashboardIconGroup?: DashboardIconGroup;

  constructor(data?: IDashboardIcon) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.navigationMenuItem = _data["navigationMenuItem"] ? NavigationMenuItem.fromJS(_data["navigationMenuItem"]) : <any>null;
      this.dashboardIconGroup = _data["dashboardIconGroup"] ? DashboardIconGroup.fromJS(_data["dashboardIconGroup"]) : <any>null;
    }
  }

  static fromJS(data: any): DashboardIcon {
    data = typeof data === 'object' ? data : {};
    let result = new DashboardIcon();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["navigationMenuItem"] = this.navigationMenuItem ? this.navigationMenuItem.toJSON() : <any>null;
    data["dashboardIconGroup"] = this.dashboardIconGroup ? this.dashboardIconGroup.toJSON() : <any>null;
    return data;
  }
}

export interface IDashboardIcon {
  id?: number;
  navigationMenuItem?: NavigationMenuItem;
  dashboardIconGroup?: DashboardIconGroup;
}

export class DashboardIconGroup implements IDashboardIconGroup {
  id?: number;
  name?: string | null;
  icons?: DashboardIcon[] | null;

  constructor(data?: IDashboardIconGroup) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      if (Array.isArray(_data["icons"])) {
        this.icons = [] as any;
        for (let item of _data["icons"])
          this.icons!.push(DashboardIcon.fromJS(item));
      }
      else {
        this.icons = <any>null;
      }
    }
  }

  static fromJS(data: any): DashboardIconGroup {
    data = typeof data === 'object' ? data : {};
    let result = new DashboardIconGroup();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["name"] = this.name !== undefined ? this.name : <any>null;
    if (Array.isArray(this.icons)) {
      data["icons"] = [];
      for (let item of this.icons)
        data["icons"].push(item.toJSON());
    }
    return data;
  }
}

export interface IDashboardIconGroup {
  id?: number;
  name?: string | null;
  icons?: DashboardIcon[] | null;
}

export class DashboardResponse implements IDashboardResponse {
  defaultDashboard?: Dashboard;
  dashboards?: Dashboard[] | null;

  constructor(data?: IDashboardResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.defaultDashboard = _data["defaultDashboard"] ? Dashboard.fromJS(_data["defaultDashboard"]) : <any>null;
      if (Array.isArray(_data["dashboards"])) {
        this.dashboards = [] as any;
        for (let item of _data["dashboards"])
          this.dashboards!.push(Dashboard.fromJS(item));
      }
      else {
        this.dashboards = <any>null;
      }
    }
  }

  static fromJS(data: any): DashboardResponse {
    data = typeof data === 'object' ? data : {};
    let result = new DashboardResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["defaultDashboard"] = this.defaultDashboard ? this.defaultDashboard.toJSON() : <any>null;
    if (Array.isArray(this.dashboards)) {
      data["dashboards"] = [];
      for (let item of this.dashboards)
        data["dashboards"].push(item.toJSON());
    }
    return data;
  }
}

export interface IDashboardResponse {
  defaultDashboard?: Dashboard;
  dashboards?: Dashboard[] | null;
}

export class DashboardWidget implements IDashboardWidget {
  id?: number;
  tag?: string | null;

  constructor(data?: IDashboardWidget) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
      this.tag = _data["tag"] !== undefined ? _data["tag"] : <any>null;
    }
  }

  static fromJS(data: any): DashboardWidget {
    data = typeof data === 'object' ? data : {};
    let result = new DashboardWidget();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["id"] = this.id !== undefined ? this.id : <any>null;
    data["tag"] = this.tag !== undefined ? this.tag : <any>null;
    return data;
  }
}

export interface IDashboardWidget {
  id?: number;
  tag?: string | null;
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
  if (result !== null && result !== undefined)
    throw result;
  else
    throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}

export class MedTaskDTO implements IMedTaskDTO {
  id?: number;
  writeRevision?: boolean | null;
  objectId?: number | null;
  objectTypeId?: number | null;
  taskState?: BaseNomDTO;
  taskType?: BaseNomDTO;
  responsableId?: number | null;
  subject?: string | null;
  description?: string | null;
  rejectReason?: string | null;
  startDate?: Date | null;
  dueDate?: Date | null;
  resolveDate?: Date | null;
  daysUntilShow?: number | null;

  constructor(data?: IMedTaskDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
          this.objectId = _data["objectId"] !== undefined ? _data["objectId"] : <any>null;
          this.objectTypeId = _data["objectTypeId"] !== undefined ? _data["objectTypeId"] : <any>null;
          this.taskState = _data["taskState"] ? BaseNomDTO.fromJS(_data["taskState"]) : <any>null;
          this.taskType = _data["taskType"] ? BaseNomDTO.fromJS(_data["taskType"]) : <any>null;
          this.responsableId = _data["responsableId"] !== undefined ? _data["responsableId"] : <any>null;
          this.subject = _data["subject"] !== undefined ? _data["subject"] : <any>null;
          this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
          this.rejectReason = _data["rejectReason"] !== undefined ? _data["rejectReason"] : <any>null;
          this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
          this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>null;
          this.resolveDate = _data["resolveDate"] ? new Date(_data["resolveDate"].toString()) : <any>null;
          this.daysUntilShow = _data["daysUntilShow"] !== undefined ? _data["daysUntilShow"] : <any>null;
      }
  }

  static fromJS(data: any): MedTaskDTO {
      data = typeof data === 'object' ? data : {};
      let result = new MedTaskDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
      data["objectId"] = this.objectId !== undefined ? this.objectId : <any>null;
      data["objectTypeId"] = this.objectTypeId !== undefined ? this.objectTypeId : <any>null;
      data["taskState"] = this.taskState ? this.taskState.toJSON() : <any>null;
      data["taskType"] = this.taskType ? this.taskType.toJSON() : <any>null;
      data["responsableId"] = this.responsableId !== undefined ? this.responsableId : <any>null;
      data["subject"] = this.subject !== undefined ? this.subject : <any>null;
      data["description"] = this.description !== undefined ? this.description : <any>null;
      data["rejectReason"] = this.rejectReason !== undefined ? this.rejectReason : <any>null;
      data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
      data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>null;
      data["resolveDate"] = this.resolveDate ? this.resolveDate.toISOString() : <any>null;
      data["daysUntilShow"] = this.daysUntilShow !== undefined ? this.daysUntilShow : <any>null;
      return data;
  }
}

export interface IMedTaskDTO {
  id?: number;
  writeRevision?: boolean | null;
  objectId?: number | null;
  objectTypeId?: number | null;
  taskState?: BaseNomDTO;
  taskType?: BaseNomDTO;
  responsableId?: number | null;
  subject?: string | null;
  description?: string | null;
  rejectReason?: string | null;
  startDate?: Date | null;
  dueDate?: Date | null;
  resolveDate?: Date | null;
  daysUntilShow?: number | null;
}


export class CashMachineDTO implements ICashMachineDTO {
  id?: number;
  writeRevision?: boolean | null;
  name?: string | null;

  constructor(data?: ICashMachineDTO) {
      if (data) {
          for (var property in data) {
              if (data.hasOwnProperty(property))
                  (<any>this)[property] = (<any>data)[property];
          }
      }
  }

  init(_data?: any) {
      if (_data) {
          this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
          this.writeRevision = _data["writeRevision"] !== undefined ? _data["writeRevision"] : <any>null;
          this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
      }
  }

  static fromJS(data: any): CashMachineDTO {
      data = typeof data === 'object' ? data : {};
      let result = new CashMachineDTO();
      result.init(data);
      return result;
  }

  toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data["id"] = this.id !== undefined ? this.id : <any>null;
      data["writeRevision"] = this.writeRevision !== undefined ? this.writeRevision : <any>null;
      data["name"] = this.name !== undefined ? this.name : <any>null;
      return data;
  }
}



export interface ICashMachineDTO {
  id?: number;
  writeRevision?: boolean | null;
  name?: string | null;
}

